/* eslint-disable eqeqeq */
/* eslint-disable radix */
exports.default = undefined;
const { extend } = require('vee-validate');

// Install rules
_default = extend('nif', {
    validate(value) {
        if (!['1', '2', '3', '5', '6', '8'].includes(value.substr(0, 1))
       && !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(value.substr(0, 2))) return false;

        const total = value[0] * 9 + value[1] * 8 + value[2] * 7 + value[3] * 6 + value[4] * 5 + value[5] * 4 + value[6] * 3 + value[7] * 2;

        const modulo11 = total - parseInt(total / 11) * 11;
        const comparador = modulo11 == 1 || modulo11 == 0 ? 0 : 11 - modulo11;

        return value[8] == comparador;
    },
});

exports.default = _default;
